import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getPayrollList = createAsyncThunk(
  "payroll/getList",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/users/payroll/`,
        { params }
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getPayrollDetail = createAsyncThunk(
  "payroll/getDetail",
  async (
    { userId, kind, date_start, date_end, page, per_page },
    { rejectWithValue }
  ) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/users/${userId}/payroll/`,
        { params: { kind, date_start, date_end, page, per_page } }
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getSalaryConfig = createAsyncThunk(
  "payroll/getSalaryConfig",
  async ({ userId, kind }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/users/${userId}/salary-config/`,
        kind ? { params: { kind } } : undefined
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const updateSalaryConfig = createAsyncThunk(
  "payroll/updateSalaryConfig",
  async ({ userId, kind, payload }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/users/${userId}/salary-config/`,
        payload,
        kind ? { params: { kind } } : undefined
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
